var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameChangeSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 114
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-change-success_svg__c",
    x1: "128.043%",
    x2: "50%",
    y1: "36.213%",
    y2: "59.452%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#42CAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.293%",
    stopColor: "#2C8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2B8CAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-change-success_svg__d",
    x1: "128.043%",
    x2: "50%",
    y1: "-22.935%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#42CAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.293%",
    stopColor: "#2C8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2B8CAB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "name-change-success_svg__a",
    d: "M0 0h210v114H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "name-change-success_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#name-change-success_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#name-change-success_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B8CAB",
    fillOpacity: 0.28,
    d: "M168.864 5.839h11.776c14.534 0-9.799-4.147 0-4.147h53.188c49.62 0 66.313.377 44.699 4.147-21.614 3.77-19.042 1.13 19.801 0 38.843-1.131 20.674 7.785-23.174 7.785-43.849 0-165.972 3.022-142.978 0 15.33-2.014 38.443-3.78 69.341-5.294l-32.653-2.491z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FCFE",
    d: "M94.474 42.861c-8.494-.25-15.389-1.03-20.684-2.337a5.21 5.21 0 00-7.607-6.938 9.66 9.66 0 00-8.765-5.595 9.66 9.66 0 00-8.827 5.729 5.21 5.21 0 00-8.115 1.673 3.861 3.861 0 00-5.177 2.987c-.484.44-1.047.93-1.687 1.473-2.246 1.906-10.13 2.908-23.656 3.008h84.518z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#name-change-success_svg__c)",
    d: "M0 149c2.866-23.566 17.353-35.349 43.46-35.349 39.162 0 42.378-33.404 68.711-46.57 26.333-13.166 36.121 8.689 64.774-10.97 28.653-19.66 49.772-36.498 80.589-21.123C278.079 45.238 281.48 83.242 267.739 149H0z",
    transform: "translate(-22 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99 17)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F493F",
    d: "M.357 36.61h74.44v40.271c0 1.124-.91 2.034-2.034 2.034H2.39a2.036 2.036 0 01-1.438-.595 2.039 2.039 0 01-.595-1.439v-40.27z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.576,
    height: 59.39,
    x: 8.263,
    fill: "#F8FCFE",
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.246,
    cy: 15.636,
    r: 8.644,
    fill: "url(#name-change-success_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M34.004 15.992l1.983 1.983 4.627-4.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AADDE3",
    fillRule: "nonzero",
    d: "M16.45 29.962h41.948v2.543H16.45v-2.543zm6.355 6.41h29.237v2.542H22.805V36.37zm3.178 6.355h22.881v2.542h-22.88v-2.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42CDB6",
    d: "M74.797 36.61v40.271c0 1.124-.91 2.034-2.034 2.034H2.497a.406.406 0 01-.203-.759L74.797 36.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61E3CD",
    d: "M.357 36.61v40.271c0 1.124.91 2.034 2.033 2.034h70.267a.408.408 0 00.203-.759L.356 36.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BA792",
    d: "M2.497 78.915a.406.406 0 01-.203-.759l35.283-20.219 35.282 20.219a.406.406 0 01-.202.759H2.497z"
  }))))));
}
export default SvgNameChangeSuccess;